var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#002240",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5264 1H1.73685C1.54142 1 1.354 1.07763 1.21582 1.21582C1.07763 1.354 1 1.54142 1 1.73685V3.64528C1 4.03066 1.15695 4.4094 1.42958 4.68203L5.42109 8.67353V14.2633C5.42123 14.3888 5.45342 14.5122 5.51459 14.6218C5.57577 14.7315 5.66391 14.8237 5.77068 14.8897C5.87745 14.9557 5.9993 14.9934 6.12471 14.9992C6.25011 15.005 6.37492 14.9787 6.48731 14.9227L9.4347 13.449C9.68449 13.3238 9.84217 13.0688 9.84217 12.7896V8.67353L13.8337 4.68203C14.1063 4.4094 14.2633 4.03066 14.2633 3.64528V1.73685C14.2633 1.54142 14.1856 1.354 14.0474 1.21582C13.9093 1.07763 13.7218 1 13.5264 1ZM8.58438 7.84753C8.51582 7.91584 8.46145 7.99703 8.42439 8.08644C8.38734 8.17585 8.36834 8.2717 8.36848 8.36848V12.3342L6.89478 13.071V8.36848C6.89492 8.2717 6.87592 8.17585 6.83887 8.08644C6.80182 7.99703 6.74744 7.91584 6.67889 7.84753L2.4737 3.64528V2.4737H12.7903L12.7918 3.64013L8.58438 7.84753Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.7ccee3eddec9d8bd93df8cb3b455558a.svg";
export { ForwardRef as ReactComponent };